import React from 'react';
import './IndustriesPage.css';

const IndustriesPage = () => {
  const [activeCard, setActiveCard] = React.useState(null);

  const industries = [
    {
      id: 'healthcare',
      name: 'Healthcare',
      subtitle: 'Diagnostics and analytics.',
      image: 'https://images.unsplash.com/photo-1576091160550-217359f49f4c?auto=format&fit=crop&q=80&w=800',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" fill="#111"/>
          <path d="M7 5H13V19H7V5Z" fill="#00d1ff" opacity="0.3"/>
          <rect x="14" y="8" width="5" height="4" fill="#ff0000" opacity="0.8"/>
          <path d="M11 10H13M12 9V11" stroke="white" strokeWidth="2" strokeLinecap="round"/>
          <path d="M15.5 10H17.5M16.5 9V11" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      bullets: ['Diagnostics', 'Patient Analytics']
    },
    {
      id: 'manufacturing',
      name: 'Manufacturing',
      subtitle: 'Predictive maintenance.',
      image: 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=800',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" fill="#111"/>
          <circle cx="12" cy="12" r="5" stroke="#7000ff" strokeWidth="2" strokeDasharray="2 2"/>
          <circle cx="12" cy="12" r="2" fill="#7000ff"/>
        </svg>
      ),
      bullets: ['Anomaly Detection', 'Predictive Maintenance']
    },
    {
      id: 'finance',
      name: 'Finance',
      subtitle: 'Fraud detection.',
      image: 'https://images.unsplash.com/photo-1611974717483-360098e046ed?auto=format&fit=crop&q=80&w=800',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" fill="#111"/>
          <path d="M12 7V17M15 9H10.5C9.67157 9 9 9.67157 9 10.5C9 11.3284 9.67157 12 10.5 12H13.5C14.3284 12 15 12.6716 15 13.5C15 14.3284 14.3284 15 13.5 15H9" stroke="#38bcf5" strokeWidth="2" strokeLinecap="round"/>
        </svg>
      ),
      bullets: ['Fraud Prevention', 'Risk Assessment']
    },
    {
      id: 'retail',
      name: 'Retail',
      subtitle: 'Customer experience.',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=800',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 3H5C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3Z" fill="#111"/>
          <path d="M9 10C9 10 9 12 12 12C15 12 15 10 15 10M7 8H17L18 18H6L7 8Z" stroke="#a18aff" strokeWidth="2"/>
        </svg>
      ),
      bullets: ['Recommendation Engines', 'Demand Forecasting']
    }
  ];

  return (
    <div className="industries-container">
      <section className="industries-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-label">Vertical Expertise</span>
          <h1>Empowering <span className="highlight">Global Industries</span></h1>
          <p>We deliver specialized AI/ML solutions tailored to the unique complexities of every sector.</p>
        </div>
      </section>

      <section className="industries-grid-section">
        <div className="section-intro">
          <h2>Sectors We Serve</h2>
          <div className="header-line"></div>
        </div>
        
        <div className="industries-grid">
          {industries.map((ind) => (
            <div 
              key={ind.id} 
              className={`industry-card ${activeCard === ind.id ? 'active' : ''}`}
              onClick={() => setActiveCard(activeCard === ind.id ? null : ind.id)}
            >
              <div 
                className="card-background" 
                style={{ backgroundImage: `url(${ind.image})` }}
              ></div>
              <div className="card-overlay"></div>
              <div className="card-content">
                <div className="industry-icon">{ind.icon}</div>
                <h3>{ind.name}</h3>
                <div className="reveal-content">
                  <p className="industry-subtitle">{ind.subtitle}</p>
                  <ul className="industry-bullets">
                    {ind.bullets.map((bullet, i) => (
                      <li key={i}>{bullet}</li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="card-border"></div>
            </div>
          ))}
        </div>
      </section>

      <section className="industries-cta">
        <div className="cta-card">
          <h2>Ready to Transform Your Industry?</h2>
          <p>Let's discuss how our AI solutions can solve your specific challenges.</p>
          <button className="primary-btn large">Book a Consultation</button>
        </div>
      </section>
    </div>
  );
};

export default IndustriesPage;
